import { cn } from '@/lib/utils';
import type { CrmDealMacroId } from './crmDealStagePresets';

export type CrmDealStepId = CrmDealMacroId;

const MACROS: { id: CrmDealMacroId; label: string; short: string }[] = [
  { id: 'sales', label: 'Продажи', short: '1' },
  { id: 'compose', label: 'Состав', short: '2' },
  { id: 'ops', label: 'Операции', short: '3' },
];

type Props = {
  active: CrmDealMacroId;
  onSelect: (id: CrmDealMacroId) => void;
  hideCompose?: boolean;
  hideSales?: boolean;
  hapticSelection: () => void;
};

export function CrmDealStepRail({ active, onSelect, hideCompose, hideSales, hapticSelection }: Props) {
  const visible = MACROS.filter((s) => {
    if (hideSales && s.id === 'sales') return false;
    if (hideCompose && s.id === 'compose') return false;
    return true;
  });

  return (
    <div
      className="flex gap-1.5 overflow-x-auto no-scrollbar pb-1 -mx-1 px-1 shrink-0"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {visible.map((s) => {
        const on = active === s.id;
        return (
          <button
            key={s.id}
            type="button"
            onClick={() => {
              hapticSelection();
              onSelect(s.id);
            }}
            className={cn(
              'press shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-bold touch-manipulation min-h-[40px]',
            )}
            style={
              on
                ? {
                    background: 'rgba(99,179,237,0.22)',
                    color: 'var(--cyan-bright)',
                    border: '1px solid var(--cyan-border)',
                  }
                : {
                    background: 'rgba(255,255,255,0.05)',
                    color: 'var(--text-3)',
                    border: '1px solid var(--border-subtle)',
                  }
            }
          >
            <span
              className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black"
              style={
                on
                  ? { background: 'rgba(99,179,237,0.35)', color: '#fff' }
                  : { background: 'rgba(255,255,255,0.08)', color: 'var(--text-3)' }
              }
            >
              {s.short}
            </span>
            {s.label}
          </button>
        );
      })}
    </div>
  );
}

export function scrollToCrmDealStep(id: CrmDealMacroId) {
  const el = document.getElementById(`crm-deal-macro-${id}`);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
